import Logo from "../../assets/CC ATS Logo.png";

export default function Loading() {
    return (
        <div className="flex items-center justify-center min-h-screen w-full bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 overflow-hidden relative">
            {/* Animated Background Gradient Orbs */}
            <div className="absolute top-20 left-10 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-400 rounded-full filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>

            {/* Content Container */}
            <div className="relative z-10 flex flex-col items-center justify-center px-4 sm:px-8">

                {/* Logo Section */}
                <div className="relative mb-12 sm:mb-16">
                    {/* Rotating Gradient Ring */}
                    <div className="absolute -inset-8 sm:-inset-12 rounded-full opacity-30" style={{
                        background: 'conic-gradient(from 0deg, #2563eb, #9333ea, #2563eb)',
                        animation: 'spin 8s linear infinite',
                        filter: 'blur(15px)'
                    }}></div>

                    {/* Secondary Ring */}
                    <div className="absolute -inset-4 sm:-inset-6 rounded-full border-2 border-transparent" style={{
                        background: 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #3b82f6, #a855f7) border-box',
                        animation: 'spin 6s linear infinite reverse'
                    }}></div>

                    {/* Logo Container */}
                    <div className="relative w-48 h-48 sm:w-64 sm:h-64 bg-white rounded-full shadow-2xl flex items-center justify-center border border-slate-200">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 to-purple-100/50 rounded-full blur-xl"></div>
                        <img
                            src={Logo}
                            alt="CareerConnect ATS Logo"
                            className="relative w-40 h-40 sm:w-56 sm:h-56 object-contain"
                            style={{ animation: 'float 3s ease-in-out infinite' }}
                        />
                    </div>
                </div>

                {/* CareerConnect ATS Branding */}
                <div className="mb-8 text-center">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black mb-2">
                        <span className="bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">Career</span>
                        <span className="text-slate-800">Connect </span>
                        <span className="bg-gradient-to-r from-purple-600 to-purple-700 bg-clip-text text-transparent">ATS</span>
                    </h1>
                    <p className="text-slate-600 text-sm sm:text-base font-medium mt-3 tracking-wide">Applicant Tracking System</p>
                </div>

                {/* Loading Progress Bar */}
                <div className="w-full max-w-md mb-10">
                    <div className="h-2 bg-slate-200 rounded-full overflow-hidden shadow-inner">
                        <div
                            className="h-full rounded-full"
                            style={{
                                background: 'linear-gradient(90deg, #3b82f6, #a855f7, #3b82f6)',
                                backgroundSize: '200% 100%',
                                animation: 'progressSlide 2.5s ease-in-out infinite'
                            }}
                        ></div>
                    </div>
                </div>

                {/* Loading Status */}
                <div className="text-center mb-8">
                    <p className="text-slate-800 text-lg sm:text-xl font-bold mb-2">
                        Loading your workspace
                    </p>
                    <p className="text-slate-600 text-sm sm:text-base">Take a deep breath… good things take time.</p>
                </div>

                {/* Animated Connection Dots */}
                <div className="flex items-center gap-2.5">
                    <div className="w-3 h-3 rounded-full bg-blue-600 shadow-lg shadow-blue-400/50" style={{ animation: 'bounce 1.4s infinite', animationDelay: '0s' }}></div>
                    <div className="w-3 h-3 rounded-full bg-purple-600 shadow-lg shadow-purple-400/50" style={{ animation: 'bounce 1.4s infinite', animationDelay: '0.2s' }}></div>
                    <div className="w-3 h-3 rounded-full bg-blue-600 shadow-lg shadow-blue-400/50" style={{ animation: 'bounce 1.4s infinite', animationDelay: '0.4s' }}></div>
                </div>
            </div>

            <style>{`
                @keyframes float {
                    0%, 100% { 
                        transform: translateY(0px) scale(1); 
                    }
                    50% { 
                        transform: translateY(-10px) scale(1.02); 
                    }
                }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                @keyframes progressSlide {
                    0% { 
                        transform: translateX(-50%);
                        background-position: 0% 50%;
                    }
                    50% { 
                        transform: translateX(0%);
                        background-position: 100% 50%;
                    }
                    100% { 
                        transform: translateX(50%);
                        background-position: 0% 50%;
                    }
                }
                @keyframes bounce {
                    0%, 100% { 
                        transform: translateY(0px);
                        opacity: 0.6;
                    }
                    50% { 
                        transform: translateY(-10px);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
}
